import { defineStore } from "pinia";


export const usePageStore = defineStore("pageStore", () => {

  const router = useRouter();

  const items = ref([]);

  function initItems(data) {
    items.value = data;
  }
   

    async function getPageByName(page)  {
        try {
                     
          const data = await useNuxtApp().$apiAuth(`/api/page/get/by/name`,{
            method: 'GET',
            params:{
              name: page
            }
           })
                             
            return {
               success: true,
               data: data?.data,
            };
       
        } catch (error) {
           
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: {}
          };
        }
      }
      async function getPageByNamePublic(page)  {
        try {
                     
          const data = await useNuxtApp().$api(`/api/page/get/by/name/public`,{
            method: 'GET',
            params:{
              ...page
            }
           })
                           
            return {
               success: true,
               data: data?.data,
            };
       
        } catch (error) {
          
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: {}
          };
        }
      }
      async function createPage(page) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/page/create`,{
            method: 'POST',
            body:{
              ...page
            }
           })
            return {
              success: true,
              data: data?.data,
            };
 
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function updatePage(page) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/page/update`,{
            method: 'PUT',
            body:{
              ...page
            }
           })
            return {
             success: true,
              data: data?.data,
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
     async function getIndexPage()  {
        try {
                     
          const {data} = await useNuxtApp().$apiAxios.get(`/api/page/get/index/page`)
                 
            return {
               success: true,
               data: data?.data,
            };
       
        } catch (error) {
             
  
           
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: {}
          };
        }
      }
      async function getMarketBySlug(title)  {
        try {
                     
          const data = await useNuxtApp().$api(`/api/page/market/by/slug`,{
            method: 'GET',
            params:{
              title: title
            }
           })
                             
            return {
               success: true,
               data: data?.data,
            };
       
        } catch (error) {
           
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: {}
          };
        }
      }
  return{
    getPageByName,
    createPage,
    updatePage,
    getPageByNamePublic,
    getIndexPage,
    getMarketBySlug
    
  }

})
